// components/Register.js
import React, { useState } from "react";
import axios from "axios";
import { useAppContext } from "../../contexts/AppContext";

const Register = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    userName: "",
    email: "",
    password: "",
    sex: "Male",
    role: "admin",
  });
  const [loading, setLoading] = useState(false);
  
  const registrationRoute = "/users/register";
  const { backendUrl } = useAppContext();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelect = (name, value) => {
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const token = localStorage.getItem("token"); // Get token for protected register route
      await axios.post(`${backendUrl}${registrationRoute}`, formData, {
        headers: { Authorization: `Bearer ${token}` }
      });
      alert("Admin registered successfully!");
      setFormData({
        firstName: "",
        lastName: "",
        userName: "",
        email: "",
        password: "",
        sex: "Male",
        role: "admin",
      });
      if (onSuccess) onSuccess();
    } catch (err) {
      console.error("Error registering", err);
      alert(err.response?.data?.message || "Error registering admin");
    } finally {
      setLoading(false);
    }
  };

  const roles = [
    { value: "admin", label: "Admin", icon: "bi bi-person", desc: "Standard access" },
    { value: "superadmin", label: "Super Admin", icon: "bi bi-shield-lock", desc: "Full system access" }
  ];

  const sexes = [
    { value: "Male", icon: "bi bi-gender-male" },
    { value: "Female", icon: "bi bi-gender-female" },
    { value: "Other", icon: "bi bi-gender-ambiguous" }
  ];

  return (
    <>
      <div className="d-flex justify-content-center w-100">
        <div className="bg-white rounded-3 shadow-sm p-4 w-100" style={{ maxWidth: "700px" }}>
          <h5 className="fw-bold mb-4">Register New Administrator</h5>
          <form onSubmit={handleSubmit} className="row g-3">
            <div className="col-md-6">
              <label className="form-label fw-semibold small text-muted">First Name</label>
              <input type="text" name="firstName" className="form-control" placeholder="First" value={formData.firstName} onChange={handleChange} required />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold small text-muted">Last Name</label>
              <input type="text" name="lastName" className="form-control" placeholder="Last" value={formData.lastName} onChange={handleChange} required />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold small text-muted">Username</label>
              <input type="text" name="userName" className="form-control" placeholder="Username" value={formData.userName} onChange={handleChange} required />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold small text-muted">Email Address</label>
              <input type="email" name="email" className="form-control" placeholder="admin@example.com" value={formData.email} onChange={handleChange} required />
            </div>
            <div className="col-12">
              <label className="form-label fw-semibold small text-muted">Password</label>
              <input type="password" name="password" className="form-control" placeholder="••••••••" value={formData.password} onChange={handleChange} required />
            </div>

            {/* Sex Selection Cards */}
            <div className="col-12 mt-4">
              <label className="form-label fw-bold small">Gender</label>
              <div className="d-flex gap-2">
                {sexes.map((s) => (
                  <div
                    key={s.value}
                    onClick={() => handleSelect("sex", s.value)}
                    className={`selection-card flex-fill text-center p-2 rounded-3 border transition-all pointer ${formData.sex === s.value ? "active" : ""}`}
                  >
                    <i className={`${s.icon} fs-5 mb-1 d-block`}></i>
                    <span className="small fw-bold">{s.value}</span>
                  </div>
                ))}
              </div>
            </div>

            {/* Role Selection Cards */}
            <div className="col-12 mt-4">
              <label className="form-label fw-bold small">Account Role</label>
              <div className="row g-2">
                {roles.map((r) => (
                  <div key={r.value} className="col-6">
                    <div
                      onClick={() => handleSelect("role", r.value)}
                      className={`selection-card d-flex align-items-center p-2 rounded-3 border transition-all pointer h-100 ${formData.role === r.value ? "active" : ""}`}
                    >
                      <div className="role-icon-box me-2 rounded-circle d-flex align-items-center justify-content-center bg-light">
                        <i className={`${r.icon} fs-5`}></i>
                      </div>
                      <div>
                        <div className="fw-bold small">{r.label}</div>
                        <div className="text-muted" style={{ fontSize: "10px" }}>{r.desc}</div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className="col-12 mt-4">
              <button type="submit" className="btn btn-primary w-100 py-2 fw-bold shadow-sm" disabled={loading}>
                {loading ? "Registering..." : "Create Admin Account"}
              </button>
            </div>
          </form>
        </div>
      </div>

      <style>{`
        .selection-card {
          border-color: #dee2e6 !important;
          background: #fdfdfd;
        }
        .selection-card:hover {
          border-color: var(--primary-color) !important;
          background: #fff;
        }
        .selection-card.active {
          border-color: var(--primary-color) !important;
          background: rgba(255, 165, 0, 0.05);
          box-shadow: 0 4px 15px rgba(255, 165, 0, 0.15);
        }
        .role-icon-box {
          width: 45px;
          height: 45px;
          color: #6c757d;
        }
        .selection-card.active .role-icon-box {
          background: var(--primary-color) !important;
          color: white !important;
        }
        .selection-card.active .fw-bold {
          color: var(--primary-color);
        }
      `}</style>
    </>
  );
};

export default Register;
